export default function (xhr){
    xhr.setRequestHeader('X-CSRF-TOKEN', window.config.csrf);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('X-Route-Name', window.config.currentRouteName);
    return xhr;
}
